import React from 'react';
import { ageInMonths, formatAge } from './age';

export const RatingItem = ({ item, isSelected = false, onSelect = () => {} }) => {
  const updated = new Date(item.updatedAt).toLocaleString("ru", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    });
  const age = ageInMonths(item.avgCreationDate);
  return (
    <tr
      className={`rating-row${isSelected ? ' selected' : ''}`}
      onClick={() => onSelect(item)}
    >
      <td>{updated}</td>
      <td className="cell-keyword">
        {/* Ссылка ведёт на Adobe — stopPropagation, чтобы клик по ней не переключал ещё и график */}
        <a
          href={item.url}
          target="_blank"
          rel="noreferrer"
          title={item.keyword}
          onClick={(e) => e.stopPropagation()}
        >
          {item.keyword}
        </a>
      </td>
      <td className="col-type"><span className={`badge-type badge-${item.contentType.toLowerCase()}`}>{item.contentType}</span></td>
      {/* totalResults допускает null (не спарсился с страницы Adobe) — прочерк, чтобы это не
          выглядело как ноль работ в выдаче. ?? , а не || — реальный 0 должен показываться. */}
      <td>{item.totalResults ?? '—'}</td>
      {/* Средний возраст работ. Прочерк — возраст неизвестен (avgCreationDate ещё не посчитан
          у записей, сохранённых до появления поля), это не то же самое, что «0 месяцев». */}
      <td>{age === null ? '—' : formatAge(age)}</td>
      <td className="cell-score"><strong>{item.score}</strong></td>
      <td className="cell-level col-level">{item.level}</td>
      <td>{item.averageRating.toFixed(0)}</td>
      <td className="col-density">
        <div className="density-info">
          <span>Top: {item.topDensity}%</span>
          <span>Elite: {item.eliteDensity}%</span>
        </div>
      </td>
    </tr>
  );
};